import React from "react";

const steps = [
  { num: "1", title: "Tu proposes ton expertise", desc: "En t’inscrivant comme tuteur." },
  { num: "2", title: "On t’accompagne", desc: "Avec des outils, une équipe et des ressources pédagogiques." },
  { num: "3", title: "Tu rejoins un parcours", desc: "Et tu inspires la prochaine génération." },
];

const HowItWorks = () => (
  <section className="w-full bg-light-4 py-12 px-6">
    <div className="max-w-5xl mx-auto text-center">
      <h3 className="text-title font-bold text-dark-1 mb-8">Comment ça marche ?</h3>
      <div className="grid gap-8 md:grid-cols-3">
        {steps.map((s, i) => (
          <div key={i} className="p-6 bg-white rounded-2xl shadow hover:shadow-lg transition">
            <div className="text-3xl font-bold text-blue-1 mb-3">{s.num}</div>
            <h4 className="font-semibold text-dark-1">{s.title}</h4>
            <p className="text-light-1 text-sm">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HowItWorks;
